import EventCard from './EventCard';
import './FeaturedEventsSidebar.css';

export default function FeaturedEventsSidebar({ events }) {
 	return(
 		<section className="sidebar featured">
 			<div className="container">
 				<header>
 					<h2>Featured</h2>
 				</header>
 				<div className="events">
 					{events.map(details => <EventCard key={details.eventID} details={details} />)}
 				</div>
 			</div>
 		</section>
	);
}